// ----------------------------------------------------------------------

export const fallbackLng = "en";
export const languages = ["en", "nl", "fr"];
export const defaultNS = "common";

export type LanguageValue = (typeof languages)[number];

// ----------------------------------------------------------------------

export const changeLangMessages: Record<
	LanguageValue,
	{ success: string; error: string; loading: string }
> = {
	en: {
		success: "Language has been changed!",
		error: "Error changing language!",
		loading: "Loading...",
	},
	nl: {
		success: "Taal is gewijzigd!",
		error: "Fout bij het wijzigen van taal!",
		loading: "Laden...",
	},
	fr: {
		success: "La langue a été changée !",
		error: "Erreur lors du changement de langue !",
		loading: "Chargement...",
	},
};
